import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Select from "react-select";

export default function ParentsMaintenanceItemSelect({ allStandardMaintenanceItems, setMaintenanceItem, maintenanceItem }) {
  const { itemId } = useParams();
  let filteredOptions = allStandardMaintenanceItems?.filter((item) => item.id !== itemId);
  const maintanenceItemOptions = filteredOptions?.map((item) => ({
    value: item.id,
    label: item.name,
  }));
  return (
    <>
      <Select
        options={maintanenceItemOptions ? [{ value: null, label: "اختر العنصر" }, ...maintanenceItemOptions] : []}
        isSearchable
        onChange={(e) =>
          setMaintenanceItem((prev) => ({
            ...prev,
            [prev.parent_id ? "schedule_id" : "parent_id"]: e.value,
          }))
        }
        placeholder="اختر العنصر الرئيسي"
        classNames={{
          control: (state) => (state.isFocused ? "selectSearchFocus" : "selectSearch"),
        }}
      />
    </>
  );
}
